/* eslint-disable no-unused-vars */
import React, {useState, useEffect} from 'react';
import {collection, query, getDocs} from 'firebase/firestore';
import {db} from '../../../firebase';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

interface ClientProps {
  id: string,
  name: string
  emails: string[],
}

const ReleasesRegisteredEmails = () => {
  const [clients, setClients] = useState<ClientProps[]>();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (loading) {
      const q =
        query(
            collection(db, 'customerEmails'),
        );

      const fetchData = async () => {
        const querySnapshot = await getDocs(q);
        let newData: any[] = [];

        querySnapshot.forEach((doc) => {
          newData = [...newData, {id: doc.id, ...doc.data()}];
        });
        setClients(newData);
        setLoading(false);
      };

      fetchData();
    }
  }, [clients, loading]);

  if (loading) {
    return (
      <Grid
        container
        spacing={4}
        style={{
          justifyContent: 'center',
          alignContent: 'center',
          textAlign: 'center',
        }}
      >
        <Grid item xs={12}>
          <CircularProgress
            style={{
              padding: '20em 0',
            }}
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid
      container
      spacing={2}
      style={{
        justifyContent: 'center',
      }}
    >
      {clients &&
        clients.map((client: ClientProps, index: number) =>
          <Grid
            key={index}
            item xs={12}
            style={{
              paddingTop: '2em',
              maxWidth: '600px',
            }}
          >
            <Paper style={{
              padding: '1em 1em 1em 1em',
            }}>
              <Grid container>
                <Grid item xs={6}>
                  <Typography variant="h5">
                    {client.name}
                  </Typography>
                  <Typography variant="subtitle2">
                    id: {client.id}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  {console.log(client.emails)}
                  {client.emails.map((email) =>
                    <Typography key={email} variant="subtitle2">
                      {email}
                    </Typography>,
                  )}
                </Grid>
              </Grid>
            </Paper>
          </Grid>,
        )
      }
    </Grid>

  );
};

export default ReleasesRegisteredEmails;
